import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propBoolField, propNumberField, propTextField } from "../../common/entityStoreForm";
import { propRequired, propMinValue, propLengthMax, propValidValue, propValueValidator } from "../../common/entityStoreValidators";
import { CustomerNoteTypeDto, CustomerNoteTypeEditDto, newCustomerNoteType } from "./types";
import { useCustomerNoteTypes } from "../../common/enum";
import { UseListStore } from "../../common/listStore";

export const CustomerNoteTypeDialog = (props: {
    close: () => void;
    customerNoteTypes: CustomerNoteTypeEditDto | null;
    onChange(): void;
    useListStore: UseListStore<CustomerNoteTypeDto>;
}) => {
    const [{ useCustomerNoteTypesDialogStore }] = useState(() => {
        const useCustomerNoteTypesDialogStore = createEntityStore<CustomerNoteTypeEditDto>({
            data: props.customerNoteTypes === null ? newCustomerNoteType() : { ...props.customerNoteTypes },
            path: "settings/customerNoteTypes",
            fetchOnInit: false,
            id: props.customerNoteTypes != null ? props.customerNoteTypes.id : null,
            getNewId: p => p.id!,
            onSaved() {
                props.onChange();
                props.close();
                useCustomerNoteTypes.getState().uninit();
            },
            propValidators: [
                propRequired("name"),
                propLengthMax("name", 50),
                propRequired("code"),
                propLengthMax("code", 3),
                propValueValidator("code", (p, e) =>
                    props.useListStore.getState().items.some(r => r.code === p && (e.id == null || e.id !== r.id)) &&
                    "Code must be unique."),
                propValidValue("priority", "priorityFormatted"),
                propRequired("priority"),
                propMinValue("priority", 0)
            ]
        });

        return { useCustomerNoteTypesDialogStore };
    });

    const { save } = useCustomerNoteTypesDialogStore(p => ({ save: p.save, id: p.entityId }));
    return <>
        <DialogTitle>{props.customerNoteTypes === null ? `New note action types ` : `Edit note action types - ${props.customerNoteTypes?.name}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={12}>{propTextField(useCustomerNoteTypesDialogStore)("name", "Name",)}</Grid>
                <Grid item xs={12}>{propTextField(useCustomerNoteTypesDialogStore)("code", "Code",)}</Grid>
                <Grid item xs={12}>{propBoolField(useCustomerNoteTypesDialogStore)("active", "Active",)}</Grid>
                <Grid item xs={12}>{propNumberField(useCustomerNoteTypesDialogStore)("priority", "priorityFormatted", "Priority",)}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};